import { supabaseClient } from "@/lib/supabase";
import { UserMetadata } from "@supabase/supabase-js";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export async function selectUserMetadata(userMetadata: UserMetadata) {
    const { data, error } = await supabaseClient
        .functions.invoke("public-select-user-metadata", {
            body: {
                ...userMetadata,
            },
        });

    if (error) {
        throw error;
    }
    return data;
}

export const createUserMetadataQueryKey = (userMetadata: UserMetadata) => [
    "user_metadata",
    { userMetadata },
];

export const userMetadataQueryOptions = (userMetadata: UserMetadata) =>
    queryOptions({
        queryKey: createUserMetadataQueryKey(userMetadata),
        queryFn: async () => selectUserMetadata(userMetadata),
    });

export const useUserMetadataQuery = (userMetadata: UserMetadata) => {
    const options = userMetadataQueryOptions(userMetadata);
    return useSuspenseQuery(options);
};
